import * as React from 'react'

interface IPageContainerProps {
  containerStyle?: string
  containerClass?: string
  children?: JSX.Element
}

const PageContainer = ({ containerStyle = '', containerClass = '', children }: IPageContainerProps) => <div
  className={`${containerClass} ${containerStyle}`}
>
  {children}
</div>

export default PageContainer



// WEBPACK FOOTER //
// ./src/components/generic/PageContainer.tsx